export function isTurboNative() {
    return document.body.classList.contains("turbo-native")
}

export function nativeHaptic(style = "light") {
    if (!isTurboNative()) return
    window.webkit?.messageHandlers?.nativeBridge?.postMessage({ action: "haptic", style })
}

export function nativeSetBadge(count) {
    if (!isTurboNative()) return
    window.webkit?.messageHandlers?.nativeBridge?.postMessage({ action: "badge", count })
}

export function nativeRequestPush() {
    if (!isTurboNative()) return
    window.webkit?.messageHandlers?.nativeBridge?.postMessage({ action: "requestPushPermission" })
}
